import { createFileRoute } from "@tanstack/react-router"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import BillingAnalytics from "@/components/coreAnalytics/BillingAnalytics"

function TimeEntryPage() {
  return (
    <Box>
      <Box sx={{ padding: "30px 30px 0" }}>
        <Typography variant="h3" sx={{ fontWeight: 600 }}>
          Time Entry Data
        </Typography>
      </Box>
      <BillingAnalytics />
    </Box>
  )
}

export const Route = createFileRoute("/core/analytics/time-entry")({ component: TimeEntryPage })
